module.exports = __webpack_public_path__ + "img/metro-icon.d823dc6b.png";